import React from "react"

let ToolTipComponent = (props) => {




    return (

        <div>
            <span className="tooltip-icon" onClick={props.handleClick}>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                     viewBox="0 0 12 12">
                    <path fill="#323232" fillRule="evenodd"
                          d="M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0zm-.003 10.974a4.976 4.976 0 1 1 0-9.953 4.976 4.976 0 0 1 0 9.953zM7.24 7.579c-.146 0-.716.843-1.028.843-.083 0-.124-.07-.124-.139 0-.158.114-.406.176-.555l.748-1.934c.373-.962-.104-1.22-.55-1.22-.603 0-1.142.288-1.557.665-.135.129-.47.63-.47.819 0 .063.063.137.137.137.19 0 .56-.966.945-.966.083 0 .176.09.104.268l-.727 1.745c-.072.169-.425.747-.425 1.223 0 .377.259.78.633.78 1.048 0 2.262-1.23 2.262-1.517 0-.09-.072-.149-.124-.149zM7.031 2.75c-.457 0-.851.357-.851.793 0 .407.28.675.706.675.467 0 .861-.337.861-.793 0-.407-.3-.675-.716-.675z"/>
                </svg>
                <span className="text">
                    [ ??? ]
                </span>
            </span>
            <div className={props.className}>
                <button type="button" onClick={props.handleClick}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                        <path fill="#323232" fillRule="evenodd"
                              d="M7.957 6L12 1.868 10.164 0 6.116 4.119 6 4l-.116.119L1.836 0 0 1.868 4.043 6 0 10.132 1.836 12l4.048-4.119L6 8l.116-.119L10.164 12 12 10.132 7.957 6z"/>
                    </svg>
                </button>
                <span className="tooltip-content-text">{props.text}</span>
            </div>
        </div>
    )

};

class ToolTip extends React.Component {

    constructor(props){
        super(props);
        this.state = { opened : false }
    }

    stateClassName = () =>{
        return this.state.opened ? "tooltip-content-wrap active" : "tooltip-content-wrap"
    };

    render = () => {
        return <ToolTipComponent text={this.props.text} className={this.stateClassName()} handleClick={() => {this.setState({opened: !this.state.opened})}}/>
    }
}


export default ToolTip